import { render, staticRenderFns } from "./reportePro.vue?vue&type=template&id=2bc4bccd"
import script from "./reportePro.vue?vue&type=script&lang=js"
export * from "./reportePro.vue?vue&type=script&lang=js"
import style0 from "./reportePro.vue?vue&type=style&index=0&id=2bc4bccd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports